import { useEffect, useState } from "react";
import styled from "styled-components";

const POSITION = {
  "1": {
    lat: 47.886109,
    lng: 106.334754,
    z: 3.4,
  },
  "2": {
    "lat": 31.2064,
    "lng": -7.8665,
    z: 5.14
  },
  "3": {
    "lat": 30.5977,
    "lng": 34.7633,
    z: 4.5
  },
  "4": {
    "lat": 32.43,
    "lng": -110.91,
    z: 4.5
  },
  "5": {
    "lat": 36.1639,
    "lng": 128.9759515,
    z: 5.5
  },
  "0": {
    "lat": 36.399598,
    "lng": 127.375208,
    z: 5.5
  }
} as {
  [id: string]: {
    lat: number;
    lng: number;
    z: number;
  }
}

const Container = styled.div`
  width: 100%;
  margin-top: 6px;

  iframe {
    width: 100%;
    height: 500px;
  }
`;

const SatIframe = ({id}: {id: string}) => {
  const value = POSITION[id];
  
  return <Container>
    <iframe src={`https://imweather.com/?model=nowcast&run=&member=&element=satellite_infrared&level=undefined&lat=${value.lat}&lng=${value.lng}&z=${value.z}`}></iframe>
  </Container>
}

export default SatIframe;